import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {CreditNote, ICreditNote} from 'app/blocks/model/credit-note.model';
import {CreditNoteService} from 'app/blocks/service/api/credit-note.service';
import {faReceipt} from '@fortawesome/free-solid-svg-icons';

@Injectable({
    providedIn: 'root'
})
export class CreditNoteResource extends AbstractEntityResource<ICreditNote> {
    constructor(creditNoteService: CreditNoteService, router: Router) {
        super(
            Resource.CREDIT_NOTES,
            creditNoteService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CREDIT_NOTES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CREDIT_NOTES),
            (entity?) => new CreditNote(entity),
            (entity) => entity.id,
            faReceipt
        );
    }
}
